import { isPresent } from 'shared/lib/utils';

import { ensureImmutable } from '@/lib/data/utils';

export function isAuthenticated(sessionOrSessionData) {
  if (!sessionOrSessionData) {
    return false;
  }

  const session = ensureImmutable(sessionOrSessionData);

  return isPresent(session.get('user')) && isPresent(session.get('session'));
}
